// extracted by mini-css-extract-plugin
export default {"crossSiteLabel":"cV-z","vrsnlCrossSiteLabel":"dV-z"};